<mat-tab-group mat-align-tabs="start" style="padding-top: 20px">
  <mat-tab label="K - 2nd Grade">
    <contest-gallery *ngIf="isLoggedIn && year > 0" [year]="year" [gradeCategoryId]="gradeCategoryIdKTo2" [gradeCategoryName]="gradeKTo2Label"></contest-gallery>
  </mat-tab>
  <mat-tab label="3rd - 5th Grade">
    <contest-gallery *ngIf="isLoggedIn && year > 0" [year]="year" [gradeCategoryId]="gradeCategoryId3To5" [gradeCategoryName]="grade3To5Label"></contest-gallery>
  </mat-tab>
  <mat-tab label="6th - 8th Grade">
    <contest-gallery *ngIf="isLoggedIn && year > 0" [year]="year" [gradeCategoryId]="gradeCategoryId6To8" [gradeCategoryName]="grade6To8Label"></contest-gallery>
  </mat-tab>
  <mat-tab label="9th - 12th Grade">
    <contest-gallery *ngIf="isLoggedIn && year > 0" [year]="year" [gradeCategoryId]="gradeCategoryId9To12" [gradeCategoryName]="grade9To12Label"></contest-gallery>
  </mat-tab>
</mat-tab-group>
